var _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _g4, _path6, _g5, _path7, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthiopia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_27006",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4946 0.761719H0.931641V20.3397H34.4946V0.761719Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_27006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4946 0.761719H0.931641V20.3397H34.4946V0.761719Z",
    fill: "#D03633"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_27006",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4946 0.761719H0.931641V20.3397H34.4946V0.761719Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_27006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4946 0.761719H0.931641V13.8167H34.4946V0.761719Z",
    fill: "#F2DD30"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_27006",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4946 0.761719H0.931641V20.3397H34.4946V0.761719Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_27006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4946 0.761719H0.931641V7.29272H34.4946V0.761719Z",
    fill: "#2D6C41"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_27006",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4946 0.761719H0.931641V20.3397H34.4946V0.761719Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_27006)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_27006",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4946 0.761719H0.931641V20.3397H34.4946V0.761719Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_27006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6064 10.5543C22.6064 13.2533 20.4154 15.4493 17.7114 15.4493C15.0074 15.4493 12.8164 13.2543 12.8164 10.5543C12.8164 7.84726 15.0074 5.65625 17.7114 5.65625C20.4154 5.65625 22.6064 7.84726 22.6064 10.5543Z",
    fill: "#4BA2D7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_27006",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4946 0.761719H0.931641V20.3397H34.4946V0.761719Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_27006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9893 9.3241H16.8333L17.4763 7.34412L17.6473 7.87512L16.7123 10.7542L16.4343 10.5511L16.7253 9.6571H14.4383L13.9893 9.3241ZM15.4103 13.7031L16.2893 11.0001L14.6043 9.77313H15.1603L17.6083 11.5501L17.3303 11.7531L16.5673 11.1981L15.8593 13.3781L15.4103 13.7031ZM20.0143 13.7031L17.7123 12.0311L16.0283 13.2542L16.2003 12.7311L18.6463 10.9501L18.7513 11.2781L17.9903 11.8291L19.8413 13.1771L20.0143 13.7031ZM21.4343 9.3241L19.1343 11.0001L19.7783 12.9811L19.3293 12.6531L18.3953 9.77411H18.7373L19.0283 10.6721L20.8803 9.3241H21.4343ZM17.7123 6.62109L18.5913 9.3241H20.6743L20.2243 9.65613H17.1993L17.3063 9.3241H18.2493L17.5413 7.14813L17.7123 6.62109Z",
    fill: "#F2DD30"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_27006",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4946 0.761719H0.931641V20.3397H34.4946V0.761719Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_27006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7949 14.4689H17.6319V12.3479H17.7949V14.4689ZM21.4109 11.8359L19.3939 11.1839L19.4449 11.0319L21.4629 11.6839L21.4109 11.8359ZM14.0139 11.8359L13.9629 11.6839L15.9819 11.0319L16.0319 11.1839L14.0139 11.8359ZM18.8349 9.14789L18.7019 9.05389L19.9489 7.33887L20.0789 7.43286L18.8349 9.14789ZM16.5939 9.14789L15.3449 7.43286L15.4769 7.33887L16.7229 9.05389L16.5939 9.14789Z",
    fill: "#F2DD30"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthiopia);
export default __webpack_public_path__ + "static/media/ETHIOPIA.e6d0a23e4764aea76929d15d7b4023b4.svg";
export { ForwardRef as ReactComponent };